var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14C0.447716 14 0 13.5523 0 13V13C0 12.4477 0.447715 12 1 12H17C17.5523 12 18 12.4477 18 13V13C18 13.5523 17.5523 14 17 14H1ZM1 8C0.447716 8 0 7.55228 0 7V7C0 6.44772 0.447715 6 1 6H17C17.5523 6 18 6.44772 18 7V7C18 7.55228 17.5523 8 17 8H1ZM1 2C0.447716 2 0 1.55228 0 1V1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V1C18 1.55228 17.5523 2 17 2H1Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.9da68e13500f9d5dc9addc921be54482.svg";
export { ForwardRef as ReactComponent };